<template>
  <div class="p-8">
    <TitreUn :content="t('detail')"/>

    <div class="grid grid-cols-2 gap-2 mt-2">
      <InputField :placeholder="t('email')" v-model="utilisateur.email" showLabel />
      <InputField :placeholder="t('delivry')" v-model="utilisateur.livraison" showLabel />
      <DropDownField :placeholder="t('role')" :values="utilisateurStore.rolesAvailable.map(role => ({id: role.uuid, display: role.libelle}))"
        v-model="utilisateur.uuidRole" showLabel />
      <DropDownField :placeholder='t("chooseALanguage")' :label='t("language")'
        :values="enumeration.countryAvailable" v-model="utilisateur.langueCode" required showLabel />
      <DropDownField :placeholder="t('subscribedToEmail')" :values="enumeration.yesNoParams" v-model="utilisateur.subscribedEmail" showLabel />
      <DropDownField :placeholder="t('notifyAdmin')" :values="enumeration.yesNoParams" v-model="utilisateur.notifyAdmin" showLabel />
    </div>

    <div class="flex w-full justify-end mt-2">
      <BlueButton :text="t('save')" @click="save" />
    </div>

    <BlueSpacer/>

    <TitreUn :content="t('editPassword')"  class="mt-8"/>

    <div class="grid grid-cols-2 gap-2 mt-2">
      <InputField :placeholder="t('password')" v-model="password" type="password" />
      <InputField :placeholder="t('confirmPassword')" v-model="confirmPassword" type="password" />
    </div>

    <div class="flex w-full justify-end mt-2">
      <BlueButton :text="t('save')" @click="savePassword" />
    </div>

    <BlueSpacer/>

    <StatistiqueUtilisateur :stats="stats" />
  </div>
</template>

<script setup>

import {UtilisateurStores} from "@/stores/UtilisateurStores";
import {enumeration} from "../../Enumeration";
import {t} from "@/utils/Traduction";
import {router} from "@/routeur";
import {NotificationStores} from "@/stores/NotificationStores";
import {defineProps, reactive, ref} from "vue";
import InputField from "@/components/molecules/InputField.vue";
import DropDownField from "@/components/molecules/DropDownField.vue";
import TitreUn from "@/components/atoms/TitreUn.vue";
import BlueButton from "@/components/molecules/BlueButton.vue";
import BlueSpacer from "@/components/atoms/BlueSpacer.vue";
import StatistiqueUtilisateur from "@/components/organismes/StatistiqueUtilisateur.vue";
import xhr from "@/utils/xhr";
import {jsonValidator} from "@/utils/JsonValidator";

const utilisateurStore = UtilisateurStores();
const notificationStore = NotificationStores();

if(utilisateurStore.role !== enumeration.role.ADMIN) {
  utilisateurStore.logout(false);
  notificationStore.addNotification(t("youNeedToBeAdminToAccessThisPage"), 'error');
  router.push({ path: "/"});
}

const props = defineProps({
  uuid: {
    type: String,
    required: true,
  },
});

const password = ref('');
const confirmPassword = ref('');

const utilisateur = reactive({
  uuid: '',
  uuidRole: '',
  uuidLangue: '',
  email: '',
  langue: '',
  role: '',
  livraison: '',
  subscribedEmail: 0,
  notifyAdmin: 0
})

let stats = reactive({value: {
  utilisateur: {email: ''},
  nbPiecesTotal: 0,
  nbCommandes: 0,
  nbCommandesAnnuler: 0,
  avgPiecesParCommande: 0,
  nbPoidsTotal: 0,
  avgPoids: 0,
  nbTempsTotal: 0,
  avgTemps: 0,
  prixProductionTotal: 0,
  prixTotal: 0,
  couleurs: [],
  resteAPayer: 0,
  nbProduitParImprimante: [],
}});

utilisateurStore.loadUtilisateurDetail(props.uuid).then((response) => {
  Object.assign(utilisateur, response)
});
utilisateurStore.loadRoles();
utilisateurStore.getStatsByUser(props.uuid).then((response) => {
  response.nbPoidsTotal = response.nbPoidsTotal / 1000;
  response.couleurs = response.couleurs.map((couleur) => {
    couleur.total = couleur.total / 1000;
    return couleur;
  });

  stats.value = response
});

const save = () => {
  xhr.addRequestToQueue("PUT", "/utilisateurs/update/" + utilisateur.uuid,
      {
        email: utilisateur.email,
        livraison: utilisateur.livraison,
        uuidRole: utilisateur.uuidRole,
        langue: utilisateur.langueCode,
        subscribedEmail: utilisateur.subscribedEmail === 1,
        notifyAdmin: utilisateur.notifyAdmin === 1
      }, true, true, false,
      (response) => {
        if(response.code !== 200) {
          if (response.code === 0 || !jsonValidator.validate(response.response)) {
            notificationStore.addNotification(
                t("errorDuringSavingUser"),
                "error");
          } else {
            notificationStore.addNotification(
                JSON.parse(response.response).message,
                "error");
          }
        } else {
          notificationStore.addNotification(t("userSaved"), "success");
        }
      });
}

const savePassword = () => {
  xhr.addRequestToQueue("PUT", "/utilisateurs/update/" + utilisateur.uuid + '/password',
      {
        password: password.value,
        confirmPassword: confirmPassword.value
      }, true, true, false,
      (response) => {
        if(response.code !== 200) {
          if (response.code === 0 || !jsonValidator.validate(response.response)) {
            notificationStore.addNotification(
                t("errorDuringSavingUser"),
                "error");
          } else {
            notificationStore.addNotification(
                JSON.parse(response.response).message,
                "error");
          }
        } else {
          notificationStore.addNotification(t("userSaved"), "success");

          password.value = '';
          confirmPassword.value = '';
        }
      });
}

</script>

<style scoped>

</style>